const thresholdLocOptions = [
  "Todas",
  "Portas exteriores",
  "Entrada de aptos",
  "Divisão de ambientes dentro dos aptos",
  "Entrada de áreas de Lazer",
  "Divisão de ambientes dentro da área de lazer",
  "Encontro de pisos diferentes no apartamento",
  "Encontro de pisos diferentes na área de lazer",
  "Definir Posteriormente"
];

const thresholdMatsOptions = [
  "Pedra Natural",
  "Porcelanato",
  "Concreto",
  "PVC",
  "Peça Cerâmica",
  "Pastilha",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
]

const sillOptions = [
  "Pedra Natural",
  "Porcelanato",
  "Concreto",
  "PVC",
  "Peça Cerâmica",
  "Pastilha",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
]

const pergolaOptions = [
  "Madeira",
  "ACM",
  "Concreto Armado",
  "Outro",
  "Seguir descrição do projeto",
  "Definir Posteriormente"
];

const flashingOptions = [
  "Todos os muros",
  "Todas as platibandas",
  "Muros acima de altura X",
  "Todos os muros, exceto área de lazer",
  "Todos os muros, exceto térreo",
  "Todos os muros, exceto área de lazer e térreo",
  "Outro",
  "Definir Posteriormente"
];

const flashingMats = [
  "Aço Galvanizado",
  "Alumínio",
  "Argamassado com textura",
  "Argamassado com pintura",
  "Concreto",
  "Outro",
  "Definir Posteriormente"
];

const parkingOptions = [
  "Demarcação Total",
  "Demarcação de borda total",
  "Demarcação de cantos",
  "Linhas laterais de divisão",
  "Outro",
  "Definir Posteriormente"
];

const parkingMatOptions = [
  "Pintura Acrílica",
  "Pintura Epóxi",
  "Peça Cerâmica",
  "Pastilha",
  "Porcelanato",
  "Outro",
  "Definir Posteriormente"
]

const frameOptions = [
  "EPS",
  "ACM",
  "Estrutura e Alvenaria",
  "Engrossamento de reboco",
  "Outro"
]

export const questions = [
  {
    label: "Telhado",
    toggleField: 'roof',
    questions: [{
      label: "Qual tipo de telhado será adotado?",
      path: "roofType",
      options: ["Metálico", "Fibrocimento", "Outro", "Seguir descrição do projeto", "Definir Posteriormente"],
      toCheck: "Tipo de Telhado"
    }, {
      label: "Qual estrutura do telhado?",
      path: "roofStructure",
      options: ["Madeira", "Metálico", "Outro", "Seguir descrição do projeto", "Definir Posteriormente"],
      toCheck: "Estrutura do Telhado"
    }, {
      label: "Qual tipo de calha?",
      path: "roofGutter",
      type: "single",
      options: ["Aço Galvanizado", "Alvenaria impermeabilizada", "PVC", "Alumínio", "Aço Inox", "Outro", "Seguir descrição do projeto", "Definir Posteriormente"],
      toCheck: "Tipo de Calha"
    },
    ],
  },
  {
    label: "Molduras",
    toggleField: 'frames',
    hasExtra: true,
    extraPath: 'extraFrame',
    questions: [{
      label: "Qual material das molduras?",
      path: "frameType",
      options: frameOptions,
    }]
  },
  {
    label: "Peitoris",
    toggleField: 'sill',
    hasExtra: true,
    extraPath: 'extraSill',
    questions: [{
      label: "Qual material dos peitoris do projeto?",
      path: "sill",
      options: sillOptions,
      toCheck: "Material dos Peitoris e Pingadeiras"
    }]
  },
  {
    label: "Pergolado",
    toggleField: 'pergola',
    hasExtra: false,
    questions: [{
      label: "Qual material da estrutura do pergolado?",
      path: "pergola",
      options: pergolaOptions,
      toCheck: 'Tipo de Pergolado'
    }, {
      label: "Se concreto, acabamento é o mesmo do ambiente?",
      path: "pergolaDif",
      options: ["Sim", "Não"],
    },
    ]
  },
  {
    label: "Demarcação de piso das vagas de garagem",
    toggleField: 'parking',
    hasExtra: false,
    questions: [{
      label: "Qual tipo de demarcação de vaga será seguida?",
      path: "parking",
      options: parkingOptions,
    }, {
      label: "Qual material da demarcação de vaga?",
      path: "parkingMat",
      options: parkingMatOptions,
    }]
  },
]

